import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core'
import { DataPageOfAllergy, Allergy, UiPreferences } from '../../../../api/models'
import { UntypedFormBuilder } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { DatePipe } from '@angular/common'
import { MessageService, SortEvent } from 'primeng/api'
import {
  AllergyService,
  AppSettingService,
  ColumnChooserService,
} from '../../../../api/services'
import { NgxSpinnerService } from 'ngx-spinner'
import { Customsort } from 'src/app/carefinity/directives/customsort'
import { CareFinitySession } from '../../../services/CareFinitySession'
/*import * as moment from 'moment';*/

@Component({
  selector: 'app-allergy-list',
  templateUrl: './allergy-list.component.html',
  styleUrls: ['./allergy-list.component.css'],
})
export class AllergyListComponent implements OnInit {
  Item = 'Allergies'
  allergies: DataPageOfAllergy
  selectedPatient: Allergy
  Lastpageindex: number = 1
  rows: number
  _selectedColumns: any[]
  showRecords: boolean = false

  private cols: any[]
  othercol: any[]

  pageNumber: number = 1
  sortby: string = 'Desc'
  demographicType: string = 'Allergy'
  txtSearch: string = ''
    patientFullName;
  pageSize: number = 0;
    showPatientDemographicPrint: boolean = false
    preferences: UiPreferences = {};
    setPrintFlag: boolean = false;


  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private messageService: MessageService,
    private allergyservice: AllergyService,
    private columnchooserservice: ColumnChooserService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private _spinnerService: NgxSpinnerService,
    private customsort: Customsort,
    private appSetting: AppSettingService,
  ) {}

    ngOnInit() {
    this.pageSize = CareFinitySession?.applicationSettings?.apiDataPageSize;

    this.cols = [
      { field: 'shortVisitDate', header: 'Visit Date' },
      { field: 'onSetDate', header: 'Onset Date' },
      { field: 'resolvedDate', header: 'Resolved Date' },
      { field: 'allergyDescription', header: 'Ingredient/Allergen' },
      { field: 'comment', header: 'Brand Name' },
      { field: 'allergyReaction', header: 'Reaction' },
      { field: 'providerName', header: 'Provider' },
    ]
    this.patientFullName = sessionStorage.getItem('ptName')
    this.loadAllergiesList(this.pageNumber, this.sortby)

    this.appSetting
      .appSettingGetPracticeSettings$Response()
      .subscribe((res) => {
          this.showPatientDemographicPrint = res.body.enablePatientDemographicPrint;
          if (CareFinitySession?.user.roles.patientRecordsPrint == true && this.showPatientDemographicPrint == true) {
              this.setPrintFlag = true;
          }
          else {
              this.setPrintFlag = false;
          }
      })

        const storedPreferences = localStorage.getItem('uiPreferences');
        if (storedPreferences) {
            this.preferences = JSON.parse(storedPreferences);

            this.Item = this.preferences?.allergies || 'Allergies';
        }

       
  }

  @Input() get selectedColumns(): any[] {
    // console.log(this._selectedColumns);
    return this._selectedColumns
  }
  /**
   * This method fetch Allergies List.And also binds dropdown dynamic columns  list.
   * paramOuter:: [pageNumber,sortbydirection]
   * paramInner:: [patientId,practiceId]
   * returns ::   [DataPageOfAllergy]
   */
  loadAllergiesList(pageNumber: number, sortbydirection: string) {
    this.allergyservice
      .allergyList({
        patientId: sessionStorage.getItem('ptId'),
        emrpracticeId: localStorage.getItem('EmrPracticeId'),
        pageNumber: pageNumber,
        sortbydirection: sortbydirection,
        searchText: this.txtSearch,
      })
      .subscribe(
        (respAllergies) => {
          console.log(respAllergies)
          this.allergies = respAllergies

          this.allergies.data = respAllergies.data.map((i) => ({
            ...i,
            ...i.otherColumns,
          }))

          this.rows = this.allergies.pageSize

          if (this.allergies.totalRecords > 0) {
            this.showRecords = true
          } else {
            this.showRecords = false
          }

          //for (let key in this.allergies.data[0].otherColumns) {
          //    this.cols.push({ field: key, header: key });
          //}

          let addedFields = new Set(this.cols.map((col) => col.field))

          for (var key in this.allergies.data[0].otherColumns) {
            if (this.allergies.data[0].otherColumns.hasOwnProperty(key)) {
              // Check if key is already in addedFields set
              if (!addedFields.has(key)) {
                // Add to addedFields set
                addedFields.add(key)

                // Push to this.cols
                this.cols.push({ field: key, header: key })
              }
            }
          }

          if (
            this.allergies.data[0].savedColumns != null &&
            this.allergies.data[0].savedColumns.length > 0
          ) {
            let Savednames = this.allergies.data[0].savedColumns.split(',')
            this._selectedColumns = this.cols.filter((col) =>
              Savednames.includes(col.field),
            )
          } else {
            this._selectedColumns = this.cols
          }

          // console.log(this._selectedColumns);
        },
        (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error,
            life: 3000,
          })
        },
      )
  }

  /**
   *
   * This method set the or insert the selected dynamic columns fields in columnchooser.
   *
   * paramOuter:: [any]
   * paramInner:: [columnNames,columnValue,demographicType]
   * returns ::   [StrictHttpResponse<Blob>)]
   *
   */
  set selectedColumns(val: any[]) {
    let selectedValues = [...val]

    if (selectedValues.length == 0) {
      selectedValues = this._selectedColumns = [this.cols[0]]
    } else {
      //restore original order

      this._selectedColumns = val
    }

    let filteredData = Array.prototype.map
      .call(selectedValues, (s) => s.field)
      .toString()
    let filteredValue = Array.prototype.map
      .call(selectedValues, (s) => s.header)
      .toString()

    this.columnchooserservice
      .columnChooserColumnchooser({
        columnNames: filteredData,
        columnValue: filteredValue,
        type: this.demographicType,
      })
      .subscribe((result) => {})
  }
  /**
   *
   * This method sort by Asce or Desc or toggle it the columns fields.
   *
   * paramOuter:: [SortEvent,num]
   * returns ::   [AllergyArray]
   *
   */
  customSort(event: SortEvent, num: number) {
    this.allergies.data = this.customsort.generalcustomSort(
      event,
      this.allergies.data,
    )
  }

  searchAllergies() {
    if (this.txtSearch.length > 1) {
      this.allergies = null
      this.rows = null
      this.loadAllergiesList(this.pageNumber, this.sortby)
    }
  }

  clearSearch() {
    if (this.txtSearch.length >= 0 || this.txtSearch == '') {
      this.txtSearch = ''
      this.loadAllergiesList(this.pageNumber, this.sortby)
    }
  }

  printAllergies() {
    var PrintAllergies = document.getElementById(
      'PrintAllergies_List',
    ) as HTMLElement
    const printWindow = window.open('', '_blank')
    if (printWindow) {
      const divContent = PrintAllergies.innerHTML
      printWindow.document.open()
      printWindow.document.write(
        '<html><head><title>Print::Allergies List</title>',
      )
      // Adding CSS styling for alternate rows
      printWindow.document.write('<style type="text/css">')
      printWindow.document.write(
        '    #Allergies_print_table_tbody tbody tr:nth-child(odd) {',
      )
      printWindow.document.write('        background-color: #f2f2f2;')
      printWindow.document.write('    }')
      printWindow.document.write(
        '    #Allergies_print_table_tbody tbody tr:nth-child(even) {',
      )
      printWindow.document.write('        background-color: #e6e6e6;')
      printWindow.document.write('    }')
      printWindow.document.write('</style>')
      printWindow.document.write('</head><body>')
      printWindow.document.write(divContent)
      printWindow.document.write('</body><html>')
      printWindow.document.close()
      printWindow.focus()
      printWindow.print()
      printWindow.close()
    } else {
      console.error('Failed to open print window.')
    }
  }
}
